const cssStyles = () => `
@keyframes scrollBgGridLinks {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-300px);
  }
}

@keyframes easeInScrollBanner {
  from {
    opacity: 0;
    transform: translateY(56px);
  }
  to {
    opacity: 100%;
    transform: translateY(0px);
  }
}

.featuredScrollBannerAnimated {
  -webkit-animation-delay: 250ms;
  -webkit-animation-duration: 0.25s;
  -webkit-animation-fill-mode: both;
  -webkit-animation-name: easeInScrollBanner;
  -webkit-animation-timing-function: ease-in-out;
}
`;

export default cssStyles;
